export enum ForbiddenErrorCodes {
  UnauthorisedIP = '001',
  DepartmentMode = '002',
}
